import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { playerStatKeys } from '@/hooks/player/playerStatsKeys';
import { updateTeamPlayerRole } from '@/services/actions/teamLeagueTeamPlayersActions';
import { TeamLeaguePlayerStatus } from '@/entities/TeamPlayerInfo';

interface UpdatePlayerRoleParams {
	organizationId: string;
	teamLeagueId: string;
	teamLeagueTeamId: string;
	playerId: string;
	status: TeamLeaguePlayerStatus;
	seasonId: string;
}

export const useUpdatePlayerRoleMutate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: UpdatePlayerRoleParams) => {
			try {
				const apiResponse = await updateTeamPlayerRole({
					organizationUuid: data.organizationId,
					teamLeagueUuid: data.teamLeagueId,
					teamLeagueTeamUuid: data.teamLeagueTeamId,
					playerUuid: data.playerId,
					status: data.status
				});

				if (!apiResponse.success) {
					throw new Error('Failed to update player role.');
				}
			} catch (error) {
				throw new Error(`HTTP error ${error}`);
			}
		},
		onSuccess: (_data, { organizationId, teamLeagueId, seasonId, playerId }) => {
			queryClient.invalidateQueries({
				queryKey: playerStatKeys.playerStats(organizationId, teamLeagueId, seasonId, playerId)
			});
			toast.success('Player role updated successfully.');
		},
		onError: () => {
			toast.error('An error has occurred. Please try again later.');
		}
	});
};
